import { _ as m } from "./main30.js";
import { _ as a } from "./main34.js";
import { i as y } from "./main19.js";
import { i as f } from "./main23.js";
var i = m, p = a, b = y, S = f, t = i ? i.prototype : void 0, n = t ? t.toString : void 0;
function s(r) {
  if (typeof r == "string")
    return r;
  if (b(r))
    return p(r, s) + "";
  if (S(r))
    return n ? n.call(r) : "";
  var o = r + "";
  return o == "0" && 1 / r == -1 / 0 ? "-0" : o;
}
var T = s;
export {
  T as _
};
